import { render, staticRenderFns } from "./Welcome.pug?vue&type=template&id=35ac7f4d&scoped=true&lang=pug&"
import script from "./Welcome.js?vue&type=script&lang=js&"
export * from "./Welcome.js?vue&type=script&lang=js&"
import style0 from "./Welcome.sass?vue&type=style&index=0&id=35ac7f4d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ac7f4d",
  null
  
)

component.options.__file = "Welcome.vue"
export default component.exports